if (!customElements.get('sky-faq-list')) {
  customElements.define(
    'sky-faq-list',
    class SkyFaqList extends HTMLElement {
      connectedCallback() {
        if (this.dataset.skyFaqReady === 'true') return;
        this.dataset.skyFaqReady = 'true';

        if (this.closest('.sky-faq-section--surface-home')) {
          this.querySelectorAll('details').forEach((details) => {
            details.querySelector('summary')?.addEventListener('click', (event) => {
              event.preventDefault();
              details._skyFaqAnimation?.finish();

              const opening = !details.open;
              if (opening && this.dataset.oneOpen === 'true') {
                this.querySelectorAll('details[open]').forEach((item) => {
                  if (item !== details) this.animateItem(item, false);
                });
              }
              this.animateItem(details, opening);
            });
          });
          return;
        }

        if (this.dataset.oneOpen !== 'true') return;

        this.querySelectorAll('details').forEach((details) => {
          details.addEventListener('toggle', () => {
            if (!details.open) return;

            this.querySelectorAll('details[open]').forEach((item) => {
              if (item !== details) item.removeAttribute('open');
            });
          });
        });
      }

      animateItem(details, opening) {
        details._skyFaqAnimation?.finish();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
          details.open = opening;
          return;
        }

        const startHeight = details.getBoundingClientRect().height;
        details.open = true;
        const endHeight = opening
          ? details.scrollHeight
          : details.querySelector('summary').getBoundingClientRect().height +
            parseFloat(getComputedStyle(details).borderTopWidth) +
            parseFloat(getComputedStyle(details).borderBottomWidth);

        details.dataset.skyFaqAnimating = 'true';
        details.style.overflow = 'hidden';
        const animation = details.animate(
          [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
          { duration: 260, easing: 'ease-in-out' }
        );
        details._skyFaqAnimation = animation;
        animation.onfinish = () => {
          details.open = opening;
          details.style.overflow = '';
          details._skyFaqAnimation = null;
          delete details.dataset.skyFaqAnimating;
        };
        animation.oncancel = () => {
          details.style.overflow = '';
          details._skyFaqAnimation = null;
          delete details.dataset.skyFaqAnimating;
        };
      }
    }
  );
}
